"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactPhoneNumberInput = _interopRequireDefault(require("react-phone-number-input"));
var _styles = require("@material-ui/core/styles");
require("react-phone-number-input/style.css");
var _Input = require("../Input");
var _withFormField = _interopRequireDefault(require("../hocs/withFormField"));
var _excluded = ["onChange"],
  _excluded2 = ["value", "handleChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Input = (0, _react.forwardRef)(function (_ref, ref) {
  var onChange = _ref.onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Input.InputBase, _extends({
    handleChange: onChange,
    inputRef: ref
  }, otherProps));
});
Input.propTypes = {
  onChange: _propTypes["default"].func.isRequired
};
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      '& .PhoneInputCountry': {
        padding: theme.spacing(0, 2),
        borderRadius: 5,
        backgroundColor: theme.palette.lightGrey.main,
        marginRight: theme.spacing(1)
      }
    }
  };
});

/** This component must be used as a controlled input. */
var PhoneInput = function PhoneInput(_ref2) {
  var value = _ref2.value,
    handleChange = _ref2.handleChange,
    other = _objectWithoutProperties(_ref2, _excluded2);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_reactPhoneNumberInput["default"], _extends({
    value: value,
    onChange: handleChange,
    inputComponent: Input
  }, other)));
};
PhoneInput.propTypes = {
  value: _propTypes["default"].string.isRequired,
  handleChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _withFormField["default"])({
  messagePosition: 'bottom'
})(PhoneInput);